export const LOCALE = {
    name: 'United States of America',
    locale: 'en_us',
    currency: 'USD',
    currencySymbol: '$'
};



// WEBPACK FOOTER //
// ./src/constants/locale.js